import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useIsAuthenticated } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import logo from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import whiteLogo from '../../Assets/images/home/whiteLogo.svg';
import LanguageSwitcher from '../languageSwitcher/LanguageSwitcher';
import { SignInButton } from '../SignInButton';
import { SignOutButton } from '../SignOutButton';
import { useWindowSize } from '../../utils/hooks';

export function NavigationBar({ isDark = false }) {
  const isAuthenticated = useIsAuthenticated();
  const size = useWindowSize();
  const [t] = useTranslation();

  if (isDark) {
    return (
      <div className="flex justify-between w-full px-4 py-3">
        <div className='flex items-center'>
          <Link to={isAuthenticated ? '/dashboard' : '/'}>
            <img alt="logo" height="61" src={whiteLogo} />
          </Link>
        </div>
        <div className="flex items-center">
          <LanguageSwitcher isDark={isDark} />
        </div>
      </div>
    )
  } else {
    return (
      <Navbar expand="lg" id="public_navbar_nav">
        <div
          className={size.width > 991 ? '' : `container - fluid ${size.width > 575 ? 'px-2' : 'px-4'}`}
        >
          <Nav.Link as={Link} to={isAuthenticated ? '/dashboard' : '/'}>
            <img alt="logo" height="50" src={logo} />
          </Nav.Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse>
            <Nav className={`me-auto`}>
              <Nav.Link as={Link} to="/jobs">
                {t('common.header.menu.jobs')}
              </Nav.Link>
            </Nav>
            <Nav className={`justify-content-end align-items-center`}>
              <div className={`me-4`}>
                <LanguageSwitcher />
              </div>
              <div>{isAuthenticated ? <SignOutButton /> : <SignInButton />}</div>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }
}
